import React, { useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { obraCobrancaAction, authActions } from '../../_actions'
import PropTypes from 'prop-types'
import moment from 'moment'
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  Grid,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  Input,
  Paper,
  Radio,
  RadioGroup,
  Tooltip,
  Skeleton,
  TablePagination,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { withStyles } from '@mui/styles'
import { withRouter } from 'react-router-dom'
import CircleIcon from '@mui/icons-material/Circle';
import { history, MANUAIS_CATEGORIAS } from '../../utils'
import TitleContent from '../TitleContent'
import { AccessControl } from '../../components/Utils/AccessControl'
import AccessDenied from '../Errors/AccessDenied'
import { Page } from 'components'
import { useDebounce } from 'use-debounce';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(6, 6, 6, 6)
  },
  textField: {
    fontSize: 8
  }
})

const ObraCobranca = (props) => {

  const dispatch = useDispatch()
  const { classes, className } = props
  const { obraCobranca } = props.obraCobranca
  const { totalRegistros } = props.obraCobranca
  const { isLoading } = props.obraCobranca
  const isCobranca = (authActions.isGestor() || authActions.isPrefeitura()) ? true : false;

  const [status, setStatus] = useState('');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [term, setTerm] = useState('');
  const [debounceTerm] = useDebounce(term, 1000);
  const [order] = useState('data');
  const [direction] = useState('desc');
  const [ready, setReady] = React.useState(false);

  const { idOrgao } = useSelector(
    (state) => state.usuarioOrgao
  )

  useEffect(() => {

    const fetchData = (page, limit, term) => {

      let filterModel = {
        Page: page,
        Limit: limit,
        Term: term,
        Order: order,
        Direction: direction,
        IdOrgao: (idOrgao && idOrgao != '' && idOrgao),
        Status: status
      };

      dispatch(obraCobrancaAction.getObraCobranca(filterModel, true));

    };

    fetchData(page, limit, debounceTerm, order, direction);

  }, [page, limit, debounceTerm, order, direction, idOrgao, status, term]);

  useEffect(() => {

  }, [totalRegistros, isLoading]);

  useEffect(() => {
  }, [ready, props.obraCobranca.isLoading])

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeLimit = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChange = prop => event => {
    setTerm(event.target.value);
  };

  const handleChangeRadio = prop => event => {
    setStatus(event.target.value);
  };

  return (
    <Page className={classes.root} title="Cobranças">
      <AccessControl
        rule={'obrasCobrancas.list'} //permissão necessária para acessar conteúdo
        yes={() => (
          <div>
            <TitleContent
              length={obraCobranca.length}
              subTitle={'GERÊNCIA DE OBRA'}
              title={'Lista de Cobranças'}
              telaManual={MANUAIS_CATEGORIAS.LISTAGEM_COBRANCA}
            />
            <Grid container spacing={3}>
              <Grid item xl={3} lg={3} md={3} xs={12}>
                <Input
                  id="term"
                  label="term"
                  placeholder="Filtro"
                  value={term}
                  fullWidth
                  onChange={handleChange('term')}
                />
              </Grid>
              <Grid item xl={9} lg={9} md={9} xs={12} align="right">
                <FormControl>
                  <FormLabel>
                    <Typography variant="subtitle1">Filtrar por Status </Typography>
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    onChange={handleChangeRadio('status')}
                    value={status}
                  >
                    <FormControlLabel value="0" control={<Radio size="sm" />} label={<Typography variant="subtitle2">Em Aberto</Typography>} />
                    <FormControlLabel value="1" control={<Radio size="sm" />} label={<Typography variant="subtitle2">Pago</Typography>} />
                    <FormControlLabel value="2" control={<Radio size="sm" />} label={<Typography variant="subtitle2">Todas</Typography>} />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
            <br />
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Data</TableCell>
                    <TableCell>Empresa</TableCell>
                    <TableCell>Órgão</TableCell>
                    <TableCell align="left">Obra</TableCell>
                    <TableCell align="center">Valor</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="center">Ações</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {undefined !== obraCobranca && obraCobranca.length
                    ? obraCobranca.map((n) => {

                      console.log('COBRANCA', n)
                      return (
                        <TableRow hover key={n.id}>
                          <TableCell component="th" scope="row">
                            {n.dataCobranca ? moment(n.dataCobranca).format("DD/MM/YYYY") : ''}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {n.empresa ? n.empresa.razaoSocial.toUpperCase() : ''}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {n.empresa ? n.obra.orgao?.nome.toUpperCase() : ''}
                          </TableCell>
                          <TableCell component="th" scope="row" align="left">
                            {n.obrasMedicoesCobrancas ? `#${n.obra.id} ${n.obra?.titulo.toUpperCase()}` : ''}
                          </TableCell>
                          <TableCell component="th" scope="row" align="center">
                            {n.valor ? 'R$' + n.valor.toLocaleString('pt-br', { minimumFractionDigits: 2 }) : ''}
                          </TableCell>
                          <TableCell component="th" scope="row" align="left">
                            <Tooltip
                              title={n.dataPagamento != null ? `Pago em ${moment(n.dataPagamento).format("DD/MM/YYYY HH:mm")}` : false}
                            >
                              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}> <CircleIcon sx={{ color: n.dataPagamento == null ? '#cf0d0d' : '#0d6e0d', fontSize: 12, marginRight: 1 }} /> <span>{n.dataPagamento == null ? 'EM ABERTO' : 'PAGO'}</span></div>
                            </Tooltip>
                          </TableCell>
                          <TableCell align="center">
                            <AccessControl
                              rule={'obrasCobrancas.list'} //permissão necessária para acessar conteúdo
                              yes={() => (
                                <IconButton
                                  aria-label="Visualizar"
                                  component="a"
                                  onClick={() =>
                                    history.push(`/obra/${n.idObra}`, { isCobranca, empresa: n.empresa })
                                  }
                                  size="small"
                                >
                                  <Tooltip title={'Ver detalhes'}>
                                    <Tooltip >
                                      <VisibilityIcon />
                                    </Tooltip>
                                  </Tooltip>
                                </IconButton>
                              )}
                            />
                          </TableCell>
                        </TableRow >
                      )
                    })
                    :
                    (
                      !isLoading ?
                        <TableRow>
                          <TableCell rowSpan={3} colSpan={7} align="center">Nenhum registro encontrado</TableCell>
                        </TableRow>
                        :
                        Array.apply(null, { length: 5 }).map((e, i) => (
                          <TableRow hover>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                          </TableRow>
                        ))
                    )
                  }
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={totalRegistros}
              labelRowsPerPage="Linhas por página"
              labelDisplayedRows={({ from, to }) => `${from}-${to} de ${totalRegistros}`}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={limit}
              onRowsPerPageChange={handleChangeLimit}
            />
          </div >
        )
        }
        no={() => <AccessDenied />}
      />
    </Page >
  )
}
ObraCobranca.propTypes = {
  classes: PropTypes.object.isRequired
}
const mapStateToProps = (state) => {
  return {
    obraCobranca: state.obraCobranca
  }
}
const connectedObraCobrancaPage = withRouter(
  connect(mapStateToProps, null, null)(withStyles(styles)(ObraCobranca))
)
export { connectedObraCobrancaPage as ObraCobranca }
